<template>
	<div style="width: 100%; height: 100%;" @click.stop="stop_pro" >
		<div style="height: 50%; width: 100%; padding: 0px; margin: 0px;">


      <v-chip v-if="!instance && !is_transcoder && !is_pull && channel" :text-color="$dark() ? 'white' : 'black'" color="transparent" small>
        <v-avatar>
          <v-icon>settings_ethernet</v-icon>
        </v-avatar>
        No instance
      </v-chip>

			<v-layout row>

				<v-flex shrink>
		      <v-chip v-if="!instance && is_transcoder && is_source" :text-color="$dark() ? 'white' : 'black'" color="transparent" small @click.stop="start_transcoder" style="cursor: pointer !important;">
            <template v-if="channel_type == 'output' && $is_admin()">
              <v-avatar>
                <v-icon>play_circle_outline</v-icon>
              </v-avatar>
  		        Start transcoder
            </template>
            <template v-if="channel_type == 'input'">
              <template v-if="transcoder_starting">
                <v-avatar style="padding-left: 5px;">
                  <v-progress-circular :value="20" :indeterminate="true" size="18"></v-progress-circular>&nbsp;
                </v-avatar>
                Streamer starting
              </template>
              <template v-else>
                <v-avatar style="padding-left: 5px;">
                  <v-icon>live_tv</v-icon>
                </v-avatar>
                Start streamer
              </template>
            </template>
		      </v-chip>

          <v-chip v-if="!instance && is_pull && is_source && !pull_instance" color="transparent" small @click.stop="start_pull" style="cursor: pointer !important;">
            <v-avatar>
              <v-icon>add_to_queue</v-icon>
            </v-avatar>
            Start pull
          </v-chip>

          <v-menu v-if="!instance && is_pull && is_source && pull_instance" :nudge-width="150" offset-y :close-on-content-click="false">
            <v-chip slot="activator" small color="green darken-3" :close="true" text-color="white" @input="stop_pull">
              <v-avatar>
                <v-icon>add_to_queue</v-icon>
              </v-avatar>
              <span class="cut-text">Pull Started</span>
            </v-chip>

            <div></div>
          </v-menu>

		      <v-menu offset-y :close-on-content-click="false" :nudge-width="150" v-model="instance_menu" v-if="instance">

		        <v-chip v-if="instance" slot="activator" small :color="instance_color" :close="is_transcoder && ((channel_type == 'output' && $is_admin()) || (channel_type=='input'))" text-color="white" @input="stop_transcoder" class="">
		          <v-avatar style="padding-left: 5px;">
                <template v-if="get_system_info_field('ip')">
  		            <v-icon>settings_ethernet</v-icon>
                </template>
                <template v-else>
                  <v-progress-circular :value="20" :indeterminate="true" size="18"></v-progress-circular>&nbsp;
                </template>
		          </v-avatar>
		          <span class="cut-text">{{instance_title}}</span>
		        </v-chip>

						<Instance v-model="instance_menu" :instance="instance" v-if="instance_menu && $is_admin()" />
		      </v-menu>

          <template v-if="is_transcoder && channel_type == 'input' && instance && get_system_info_field('ip') && !cloudstreamer_ready">
            <v-progress-circular :value="20" :indeterminate="true" size="18"></v-progress-circular>&nbsp;
          </template>

          <template v-if="is_transcoder && channel_type == 'input' && instance && get_system_info_field('ip') && cloudstreamer_ready">

            <v-chip small color="blue darken-4" style="cursor: pointer !important" @click.stop="open_gui">
              <v-avatar>
                <v-icon style="margin-left: 20px;">tune</v-icon>
              </v-avatar>
            </v-chip>

            <v-chip small color="blue darken-4" v-if="is_admin_channel && $is_admin()" style="cursor: pointer !important" @click.stop="open_gui_mv">
              <span class="">MV</span>
            </v-chip>

            <v-chip small color="blue darken-4" v-if="is_transcoder && channel_type == 'input' && instance && get_system_info_field('ip') && cloudstreamer_ready" style="cursor: pointer !important" @click.stop="open_streamdeck_url">
              <v-avatar>
                <v-icon style="margin-left: 20px;">keyboard</v-icon>
              </v-avatar>
            </v-chip>

          </template>


				</v-flex>

				<v-flex shrink>
					<v-chip v-if="instance && is_transcoder && is_mediaconnects && mediaconnects_status == 'standby' && $is_admin()" :text-color="$dark() ? 'white' : 'black'" color="transparent" small @click.stop="start_mediaconnects" style="cursor: pointer !important;">
		        <v-avatar>
		          <v-icon>play_circle_outline</v-icon>
		        </v-avatar>
		        Start mediaconnects
		      </v-chip>

					<v-chip v-if="is_transcoder && is_mediaconnects && mediaconnects_status != 'standby' && $is_admin()" small text-color="white" :color="get_color_for_mediaconnects_state(mediaconnects_status)" :close="mediaconnects_status == 'active'" @input="stop_mediaconnects">
						Mediaconnects
					</v-chip>
				</v-flex>
				<v-spacer />
			</v-layout>

		</div>

		<div style="height: 50%;" v-if="channel">
      <v-chip :color="channel_color" class="dashboard_chip" text-color="white" @click.stop="open_channel" small>
        <v-avatar shrink>
          <v-icon>movie</v-icon>
        </v-avatar>
        <span class="cut-text text-xs-center" style="flex: 1 1 auto;">{{ channel_title }}</span>
        <div class="shrink pr-1 pl-1" v-if="is_source && output_type != 'none' && $is_admin()">
          <span style="font-weight: bold;" v-if="output_override_time != -1">{{output_override_time}}</span> <span style="font-weight: bold; text-transform: uppercase;">{{output_type[0]}}</span> <v-icon style="vertical-align: middle;" v-if="output_state == 'active'">sensors</v-icon><v-icon style="vertical-align: middle;" v-else-if="output_state == 'error'" title="Multiple active output detected!">warning</v-icon><v-icon style="vertical-align: middle;" v-else>sensors_off</v-icon>
        </div>

        <v-icon right @click.stop="stop_router">autorenew</v-icon>

        <v-tooltip bottom v-if="kepitstreamer_connection && kepitstreamer_connection != 'connected' && $is_admin()" style="position: absolute;">
          <template v-slot:activator="{ on }">
            <v-icon style="position: absolute; right: 30px;" :color="get_color_for_state(kepitstreamer_connection)" v-on="on">warning</v-icon>
          </template>
          <span>Broadcaster -> Kepitstreamer: {{kepitstreamer_connection}}</span>
        </v-tooltip>
      </v-chip>
  	</div>
	</div>
</template>

<script>
import datelib from '@/lib/date.js'

import Instance from './Instance'
import EventModel from '@/models/event.js'
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'

export default {
	props: ["channel", "event", "type"],
	data () {
		return {
      instance_menu: false,
      timestamp: 0,
      updater: undefined,
      is_source: undefined,
      is_current: undefined,
      start_transcoder_color: undefined,
      is_transcoder: undefined,
			is_mediaconnects: undefined,
      is_pull: undefined,
      is_admin_channel: undefined,
      pull_instance: undefined,
      instance: undefined,
      instance_title: undefined,
      instance_color: undefined,
      channel_title: undefined,
      channel_color: undefined,
      channel_type: undefined,
			mediaconnects_status: undefined,
			disable_mediaconnects_button: false,
      kepitstreamer_connection: "",
      output_type: "none",
      output_state: "none",
      output_override_time: 0,
      cloudstreamer_ready: false,
      transcoder_starting: false,
		}
	},
  components: {
    Instance
  },
  mounted () {
    var self = this;
    this.timestamp = self.$store.state.timestamp;
    this.timestamp_update();

    this.updater = setInterval(function() {
      self.timestamp = self.$store.state.timestamp;
      self.timestamp_update();
    },1000);
  },
  beforeDestroy () {
    if (typeof(this.updater) != "undefined") {
      clearTimeout(this.updater);
    }
  },
	methods: {
    get_system_info_field(field) {
      return _.get(this.instance, ["system_info", field]);
    },
    is_updater () {
      return typeof(updater) != "undefined";
    },
    get_instance_color() {
      var instance = this.instance;
      var info = InstanceModel.status(instance);
      if (typeof(info) != "undefined") {
        return this.$dark() ? "green darken-3" : "green"
      }
      if (this.is_current == true) {
        return this.$dark() ? "red darken-3" : "green";
      }
      return this.$dark() ? "grey darken-3" : "blue-grey lighten-3";
    },
    get_start_transcoder_color() {
      if (this.is_current) return "red darken-2";
      return "black";
    },
    get_kepitstreamer_connection_status() {
      if(this.type == "destination") {
        var ch_input = ChannelModel.get_channel_input(this.channel, this.event);
        if(!_.isEmpty(ch_input) && _.get(ch_input, ["config", "type"]) == "tcp_pull") {
          var instance = this.instance;
          var info = InstanceModel.status(instance);
          return _.get(info, ["stats", "input_routers", _.get(ch_input, "key"), "destination", "state"], "disconnected");
        }
      }
      return undefined;
    },
    get_channel_color () {
      if(this.type == "destination") {
        var ch_input = ChannelModel.get_channel_input(this.channel, this.event);
        if(!_.isEmpty(ch_input) && _.get(ch_input, ["config", "type"]) == "tcp_pull") {
          var instance = this.instance;
          var info = InstanceModel.status(instance);
          return this.get_color_for_state(_.get(info, ["stats", "input_routers", _.get(ch_input, "key"), "source", "state"], "disconnected"));
        }
      }
      var ch = EventModel.input_channel(this.event);
      if (typeof(ch) != "undefined") {
        var info = ChannelModel.status(ch);
        if (typeof(info) != "undefined") {
          var data = info.instance;

          if (this.type == "source") {
            var color = this.get_color_for_state(data.source.state);
            if (typeof(color) != "undefined") return color;

          } else if (this.type == "destination") {
            var d  = _.find(data.destinations, (dest) => {
              return dest.events.includes(this.event.uuid);
            });

            if (typeof(d) != "undefined") {
              var color = this.get_color_for_state(d.status.state)
              if (typeof(color) != "undefined") return color;
            }
          }
        }
      }

      if (this.is_current == true) {
        return this.$dark() ? "red darken-3" : "red";
      }

      return this.$dark() ? "grey darken-1" : "blue-grey lighten-3";
    },
		get_mediaconnects_status () {
			var ch = this.channel
			if (typeof(ch) != "undefined") {
				var info = ChannelModel.mediaconnects_status(ch);
				if (typeof(info) != "undefined") {
					if(_.every(info, {status: "ACTIVE"})) {
						return "active"
					}
					if(_.every(info, {status: "STANDBY"})) {
						return "standby"
					}
					return "changing"
				}
			}
			return undefined
		},
    update_output_state() {
      if(!this.is_source) return;
      
      var ch = ChannelModel.get_channel(this.channel);

      var outputs = _.reduce(ChannelModel.outputs_list(ch), (acc, output) => {
        if(["headend", "srtla"].indexOf(output.type) == -1) return acc;

        var active = _.get(output, "active", false);
        var override = _.find(_.get(ch, "meta.overrides", []), (override) => {
          return override.type == "config:output:"+output.type && override.subtype == "active";
        });
        var override_active = _.get(override, "params.active", false);
        var override_time = _.get(override, "end_time", 0) - this.timestamp;

        if(!_.isEmpty(_.get(output, "streamid"))) return acc

        return acc.concat([{
          type: output.type,
          active: active,
          override_active: override_active,
          override_time: override_time
        }]);

      }, []);
      
      if(_.isEmpty(outputs)) {
        this.output_type = "none";
        this.output_state = "deactive";
        this.output_override_time = -1;
        return;
      }

      var active_outputs = _.filter(outputs, (output) => {
        return output.override_time > 0 ? output.override_active : output.active;
      });

      if(active_outputs.length > 1) {
        this.output_type = "multiple";
        this.output_state = "error";
        this.output_override_time = -1;
        return;
      }

      var override_deactive_output = _.find(outputs, (output) => {
        return output.override_time > 0 && !output.override_active;
      });
      if(active_outputs.length == 0 && _.isEmpty(override_deactive_output)) {
        this.output_type = "none";
        this.output_state = "deactive";
        this.output_override_time = -1;
        return;
      }

      var output = active_outputs[0] || override_deactive_output;
      
      this.output_type = output.type;
      this.output_state = (output.override_time > 0 ? output.override_active : output.active) ? "active" : "deactive";
      this.output_override_time = output.override_time > 0 ? datelib.format_duration(output.override_time, "hh:mm") : -1;
    },
    timestamp_update() {
      this.instance = ChannelModel.instance(this.channel, this.event);
      this.is_source = EventModel.is_source(this.event);
      this.is_current = EventModel.is_current(this.event, this.timestamp);
      this.start_transcoder_color = this.get_start_transcoder_color();
      this.is_transcoder = ChannelModel.is_transcoder(this.channel);
			this.is_mediaconnects = ChannelModel.is_mediaconnects(this.channel);
      this.instance_title = InstanceModel.title(this.instance);
      this.instance_color = this.get_instance_color();
      this.channel_title = ChannelModel.title(this.channel);
      this.channel_color = this.get_channel_color();
      this.channel_type = ChannelModel.get_type(this.channel);
      this.is_admin_channel = ChannelModel.is_admin(this.channel);
			this.mediaconnects_status = this.get_mediaconnects_status();
      this.is_pull = ChannelModel.is_pull(this.channel);
      this.kepitstreamer_connection = this.get_kepitstreamer_connection_status();
      this.pull_instance = InstanceModel.mediamtx_get_instance_by_channel(this.channel);

      if (this.is_cloudstreamer() && this.instance && this.get_system_info_field("ip") && this.cloudstreamer_ready == false) {
        this.check_cloudstreamer();
      }

      this.update_output_state();
    },
    is_cloudstreamer () {
      if (this.is_transcoder && this.channel_type == 'input') return true;
      return false;
    },
    stop_pro () {
    },
    open_gui() {
      if (InstanceModel.gui_url(this.instance) != "") {
        window.open(InstanceModel.gui_url(this.instance));
      }
    },
    open_gui_mv() {
      if (InstanceModel.gui_url(this.instance) != "") {
        window.open(InstanceModel.gui_url(this.instance) + "m/output0/mcr-view.html");
      }
    },
    open_streamdeck_url() {
      if (InstanceModel.gui_url(this.instance) != "") {
        window.open("streamdeck://plugins/message/fi.kepit.streamer-controller/url/" + InstanceModel.gui_url(this.instance));
      }      
    },
 		start_transcoder () {
      var self = this;
      var ch = ChannelModel.get_channel(this.channel);
      if (ch.type == "output") {
        this.disable_mediaconnects_button = true;
        EventModel.start_transcoder(this.event, (msg) => {
          self.$message.success("Transcoder started!");
          self.timestamp_update();
				  if(this.mediaconnects_status == "standby") {
            this.$nextTick(() => {
						  this.start_mediaconnects();
            })
				  }
        }, (err) => {
				  this.disable_mediaconnects_button = false;
          self.$message.success("Transcoder start failed!" + JSON.stringify(msg));
        });
      }
      if (ch.type == "input") {
        if (self.transcoder_starting == true) return;
        self.transcoder_starting = true;
                ChannelModel.start_transcoder(this.channel, (msg) => {
          self.$message.success("Transcoder started!");
          self.transcoder_starting = true;
          self.timestamp_update();
        }, (err) => {
          self.transcoder_starting = false;
          self.$message.success("Transcoder start failed!" + JSON.stringify(msg));
        });
      }
    },
    check_cloudstreamer () {
      var self = this;
      if (this.instance && this.get_system_info_field("ip")) {
        console.log("Checking cloudstreamer ready");
        var gui_url = InstanceModel.gui_url(this.instance);
        if (gui_url != "") {
          self.$http.get(gui_url + "static/test.html").then((response) => {
            self.cloudstreamer_ready = true;
            return;
          }).catch((err) => {
            console.log("Error response ",err);
          });
        }
      }
    },
    start_pull () {
      var self = this;
      var channel = ChannelModel.get_channel(this.channel);
      InstanceModel.mediamtx_add_update_pull(null, channel.name, channel.meta.pull_url, function(msg) {
      }, function(msg) {
      });
    },
    stop_pull () {
      var self = this;
      if (typeof(self.pull_instance) == "undefined" || self.pull_instance == null) return;
      var channel = ChannelModel.get_channel(this.channel);
      if (typeof(channel) == "undefined" || channel == null) return;
      InstanceModel.mediamtx_remove_pull(self.pull_instance, channel.name, function(msg) {
      }, function(msg) {
      });
    },
		start_mediaconnects () {
			var self = this;
			EventModel.start_mediaconnects(this.event, (msg) => {
				self.$message.success("Mediaconnects started!");
				self.timestamp_update();
			}, (err) => {
				self.$message.success("Mediaconnects start failed!" + JSON.stringify(msg));
			});
		},
    stop_transcoder () {
      var self = this;
      var ch = ChannelModel.get_channel(this.channel);
      if (ch.type == "output") {
        EventModel.stop_transcoder(this.event, (msg) => {
          self.$message.success("Transcoder stopped");
          self.timestamp_update();
        }, (err) => {
          self.$message.success("Transcoder stop failed!" + JSON.stringify(err));
        });
      }
      if (ch.type == "input") {
        var instance = ChannelModel.instance(this.channel);
        this.cloudstreamer_ready = false;
        InstanceModel.stop_transcoder(instance, (msg) => {
          self.$message.success("Transcoder stopped");
          self.transcoder_starting = false;
          self.timestamp_update();
        }, (err) => {
          self.$message.success("Transcoder stop failed!" + JSON.stringify(err));
        });
      }
    },
		stop_mediaconnects () {
			var self = this;
			EventModel.stop_mediaconnects(this.event, (msg) => {
				self.$message.success("Mediaconnects stopped");
				self.timestamp_update();
			}, (err) => {
				self.$message.success("Mediaconnects stop failed!" + JSON.stringify(err));
			});
		},
    stop_router () {
    	if (this.type == "destination") this.stop_destination();
    	if (this.type == "source") this.stop_source();
    },
    stop_source () {
      var self = this;
      EventModel.router_stop_source(this.event, (msg) => {
        self.timestamp_update();
      }, (err) => {
      });
    },
    stop_destination () {
      EventModel.router_stop_destination(this.event, (msg) => {
        self.timestamp_update();
      }, (err) => {
      })
    },
    get_color_for_state (state) {
      if (state == "listening") return this.$dark() ? "orange darken-2" : "yellow darken-3";
      if (state == "disconnected") return this.$dark() ? "red darken-3" : "red lighten-2";
      if (state == "connecting") return this.$dark() ? "orange darken-4" : "orange";
      if (state == "connected") return this.$dark() ? "green darken-3" : "green";
      return undefined;
    },
		get_color_for_mediaconnects_state(state) {
			if (state == "active") return this.$dark() ? "green darken-3" : "green";
			if (state == "standby") return this.$dark() ? "red darken-3" : "red lighten-2";
			if (state == "changing") return this.$dark() ? "orange darken-4" : "orange";
			return undefined;
		},
    open_channel () {
      if (this.$is_admin()) {
        var ch = ChannelModel.get_channel(this.channel);
        if (typeof(ch) != "undefined") {
          this.$router.push("/dashboard/channel/" + ch.uuid );
        }
      }
    },
   	open_instance () {
      var instance = this.instance;
      if (typeof(instance) != "undefined") {
        this.open_instance_by_id(instance.id);
      }
    },
    open_instance_by_id (instance_id) {
      this.$router.push("/dashboard/instance/" + instance_id);
    }
	},
	computed: {

	}
}
</script>
<style>

.dashboard_chip {
  width: 90% !important;
}
.dashboard_chip .v-chip__content {
  width: 100%;
  cursor: pointer !important;
}
.dashboard_chip .v-chip__content .v-chip__close {
  margin: 0px !important;
  margin-right: -3px !important;
}
.dashboard_chip .v-chip__content .v-icon--right {
  margin: 0px !important;
  margin-right: -11px !important;
}
.dashboard_chip .v-avatar {
	margin-left: -6px !important;
}

.margin {
	margin-top: 2px;
	margin-bottom: 2px;
}
.dashboard_link {
	cursor: pointer;
}
.gui_btn {
	font-size: 10px; height: 20px; min-width: 25px; width: 25px; max-width: 25px;
}
.channel-title {
/*word-break: break-all;
  white-space: normal;*/
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  }
.channel-title2 {

  text-align: left !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.cut-text { 
    display: inline-block;
    max-width: 98%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}

</style>
